import * as React from "react";
import { ReactElement, useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Heading,
  Text,
  Image,
  Button,
  useColorModeValue,
  Container,
  useToast,
  Flex,
  SimpleGrid,
  StackDivider,
  Icon,
  SpaceProps,
  HStack,
  Tag,
  Link,
  Skeleton
} from "@chakra-ui/react";
import { PageSlideFade } from "../components/page-transitions";
import { apiHost, baseUrl } from "utils/Cons/Constants";
import axios from "axios";
import { Helmet } from "react-helmet";
import headerBg from "../assets/images/bellefonte-header.jpg";
import cloudsBg from "../assets/images/cloud-background.png";
import parser from "html-react-parser";
import Masonry from "react-masonry-css";
import "../style/style.css";
import { MotionBox } from "../components/motion";
import ContentBlock from "components/content-block";
import FavoritesBlock from "components/favorites-block";
import MediaBlock from "../components/media-block";
import ImageBlock from "../components/image-block";
import CrowdBlock from "../components/crowd-block";
import MapBlock from "components/map-block";
import CTABlock from "components/cta-block";
import ImagesBlock from "components/images-block";
import ImagesGridBlock from "components/images-grid-block";
import TabsBlock from "components/tabs-block";
import SlidesBlock from "components/slides-block";
import HighlightsBlock from "components/highlights-block";
import EmbedBlock from "components/embed-block";
import BookBlock from "components/book-block";
import ShareModal from "components/share-modal";

interface PostType {
  title: string;
  summary: string;
  content_rendered: string;
  meta_title?: string;
  meta_description?: string;
  image_url?: string;
  header_image_url?: string;
  publish_at?: string;
  featured?: boolean;
  author_name?: string;
  fields?: {
    content_blocks?: any[];
    display_date?: boolean | number;
  };
}

const markdownTheme = {
  p: props => {
    const { children } = props;
    return (
      <Text mb={2} fontSize={'0.8em'}>
        {children}
      </Text>
    );
  },
};

const Post = ({ match }) => {
  const toast = useToast();

  const [destination, setDestination] = useState<PostType>({} as PostType);
  const [loading, setLoading] = useState(true);

  const breakpointColumnsObj = {
    default: 3,
    1200: 2,
    400: 1
  };

  const getExperience = () => {
    let data = {} as PostType;
    axios.get(`${apiHost}/news/get/${match.params.id}`)
      .then(res => {
        data = res.data;
        if (res.status == 200) {
          setDestination(data);
          console.log(data);
          setLoading(false);
        }
        return res;
      })
      .catch(err => console.log(err));

    return data;
  };

  const showToast = (message, status) => {
    toast({
      position: "bottom",
      description: message,
      status: status,
      duration: 5000,
      isClosable: true
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getExperience();
  }, []);

  return (
    <PageSlideFade>
      <Helmet>
        <title>{destination.meta_title || destination.title}</title>
        <meta name="description" content={destination.meta_description} />
      </Helmet>
      {loading && (
        <Container maxW={'5xl'} pt={10} pb={10}>
          <Box>
            <Skeleton height="750px" />
          </Box>
        </Container>
      )}
            {!loading && (
        <>
          <Box className="home-header-container" backgroundImage={`url(${destination.header_image_url || headerBg})`} backgroundPosition="center center" backgroundSize="cover" minHeight="800px">
        <Container maxW={'5xl'}>
          <Stack
            textAlign={'center'}
            align={'center'}
            spacing={{ base: 8, md: 10 }}
            py={{ base: 20, md: 28 }}>
            <MotionBox
              w="100%"
              opacity="0"
              initial={{
                translateY: 180
              }}
              animate={{
                translateY: 0,
                opacity: 1,
                transition: {
                  delay: 0.4,
                  duration: 0.5
                }
              }}
            >
              <Heading
                as={'h1'}
                fontFamily="american"
                fontWeight={600}
                fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                color="white"
                lineHeight={'100%'}
                textShadow="2px 2px 8px rgba(0,0,0,0.5)"
                mt={{ base: 20, md: 0 }}>
                On the Waterfront in {' '}
                <Text as={'div'} fontFamily="brush" fontWeight={500}
                  fontSize={{ base: '6rem', md: '13rem' }} color="white" textShadow="2px 2px 8px rgba(0,0,0,0.5)" mt="6rem">
                  Bellefonte
                </Text>
              </Heading>
            </MotionBox>
          </Stack>

        </Container>
      </Box>


      <Box
        backgroundImage={!destination.featured ? `url(${cloudsBg})` : undefined}
        backgroundPosition="top center"
        backgroundRepeat="no-repeat"
        backgroundSize="fit"
        marginTop={!destination.featured ? "-350px" : "0px"}
        paddingTop={!destination.featured ? "250px" : "0px"}
        className="post-page"
      >
        {destination.featured ? <Image src={destination.image_url} alt={destination.title} width="100%" height="80vh" objectFit="cover" /> : null}
        <Container maxW={!destination.featured ? "5xl" : "6xl"} marginTop={!destination.featured ? "0px" : "-350px"}>

          <Box backgroundColor={!destination.featured ? undefined : "rgba(255, 255, 255, 0.8)"} padding={!destination.featured ? "0px" : "80px"} marginTop={!destination.featured ? "20px" : "0px"} position="relative">

          {destination.fields?.display_date !== false && destination.fields?.display_date !== 0 && (
            <Box fontFamily="italic" textAlign="left" fontSize="0.9em" fontWeight="600" mt={!destination.featured ? { base: 20, md: 20 } : 0}>
              {destination.publish_at ? new Date(destination.publish_at).toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              }) : ''}
            </Box>
            )}

            <Heading
              as={'h2'}
              fontFamily="american"
              fontWeight={600}
              fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
              color="rgb(213, 31, 12)"
              lineHeight={'100%'}
              textAlign="left"
            >
              {destination.title}
            </Heading>

            {destination.author_name && (
              <Text fontSize="0.8em" textAlign="left" mb={0} color="#153b4a">
                <cite>- by {destination.author_name}</cite>
              </Text>
            )}

            {destination.summary && (
              <Text fontSize="2xl" fontWeight="bold" mb={5} textAlign="left">{destination.summary}</Text>
            )}

            {destination.content_rendered && (
              <Box className="content-block" pt={5} pb={10} textAlign="left">
                {parser(destination.content_rendered)}
              </Box>
            )}

          </Box>

        </Container>

        {destination.fields?.content_blocks?.map((block, index) => (
          <Box key={`block-${index}`}>
            {
              {
                'anomaly.extension.favorites_block_block': <FavoritesBlock page={destination} block={block} />,
                'anomaly.extension.media_block_block': <MediaBlock page={destination} block={block} />,
                'anomaly.extension.image_block_block': <ImageBlock page={destination} block={block} />,
                'anomaly.extension.crowd_block_block': <CrowdBlock page={destination} block={block} />,
                'anomaly.extension.map_block_block': <MapBlock page={destination} block={block} />,
                'anomaly.extension.cta_block_block': <CTABlock page={destination} block={block} />,
                'anomaly.extension.images_block_block': <ImagesBlock page={destination} block={block} />,
                'anomaly.extension.images_grid_block_block': <ImagesGridBlock page={destination} block={block} />,
                'anomaly.extension.tabs_block_block': <TabsBlock page={destination} block={block} />,
                'anomaly.extension.slides_block_block': <SlidesBlock page={destination} block={block} />,
                'anomaly.extension.highlights_block_block': <HighlightsBlock page={destination} block={block} />,
                'anomaly.extension.embed_block_block': <EmbedBlock page={destination} block={block} />,
                'anomaly.extension.content_block_block': <ContentBlock page={destination} block={block} />,
                'anomaly.extension.book_block_block': <BookBlock page={destination} block={block} />,
              }[block.extension]
            }
          </Box>
        ))}
        <Container maxW={!destination.featured ? "5xl" : "6xl"}>
          <SimpleGrid columns={3} pb={10}>
            <Box>
              <Button as={Link} href="/news" w="100%" fontWeight={600} borderRadius="1rem" fontSize="0.7em" color="white" bg="rgb(213, 31, 12)">
                Back to News
              </Button>
            </Box>
            <Box></Box>
            <Box>
              <ShareModal page={destination} path="posts/" />
            </Box>
          </SimpleGrid>
        </Container>
      </Box>
        </>
      )}
    </PageSlideFade>
  );
};

export default Post;
